export type ApplicationNoteTemplate = {
  id: string;
  name: string;
  category: string;
  description: string;
  /** Full internal-notes block; may include placeholders the recruiter edits. */
  body: string;
};

/**
 * Default internal-note starters for submitting a candidate to a job (ATS-style intake).
 */
export const APPLICATION_NOTE_TEMPLATES: ApplicationNoteTemplate[] = [
  {
    id: 'standard-submit',
    name: 'Standard submission',
    category: 'General',
    description: 'Fit summary + next steps — works for most roles.',
    body: `Fit summary:
• Role alignment: 
• Key strengths vs JD: 
• Gaps / watch-outs: 

Sourcing & process:
• How we engaged the candidate: 
• Availability / notice: 
• Compensation expectations (if discussed): 

Next steps:
• Proposed: share profile with client / schedule screen / await feedback.`,
  },
  {
    id: 'client-priority',
    name: 'Priority client',
    category: 'Relationship',
    description: 'When the client asked for fast turnaround or VIP handling.',
    body: `PRIORITY SUBMISSION — please expedite client review.

Why now: 
Relationship context: 

Candidate snapshot:
• Title / years relevant: 
• Top 2–3 proof points: 

Risks to flag early: 
Ask: feedback within [X] business days if possible.`,
  },
  {
    id: 'contract-interim',
    name: 'Contract / interim',
    category: 'Engagement',
    description: 'Short-term or contract-to-hire framing.',
    body: `Engagement type: Contract / interim / C2H (strike one)

Scope: 
Duration / start window: 
Location & remote policy: 

Candidate:
• Rate / salary expectation (if shared): 
• Bench / immediate availability: 

Compliance / invoicing notes: `,
  },
  {
    id: 'replacement-backfill',
    name: 'Backfill / replacement',
    category: 'Context',
    description: 'Replacing a leaver or failed hire.',
    body: `Backfill context:
• Role being replaced: 
• Reason (attrition / performance / re-org): 
• Must-match vs can-flex from previous incumbent: 

Candidate differentiation:
• How this profile addresses prior gaps: 

Sensitivity: `,
  },
  {
    id: 'referral',
    name: 'Referral track',
    category: 'Source',
    description: 'Internal or employee referral — audit trail.',
    body: `Referral source:
• Referrer name & relationship: 
• Referral date: 
• Consent to share profile: yes / pending

Candidate overview:
• Current role & employer: 
• Why interested in this role/client: 

Conflict check:
• Overlap with client employees: none / see note: `,
  },
];
